import { logger } from '@zep/core-logger';

import { type EventProperties } from '@/utils/analytics';
export const trackGnbAnalytics = (
  to: string,
  location: string,
  eventProperties?: EventProperties,
) => {
  logger.track(`enter_${to}`, {
    ...eventProperties,
    location,
  });
};
